import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { DirectDepositOtherOptions, usingDirectDeposit } from './helpers';
import content from '../../../utils/content.json';

const notUsingDirectDeposit = formData => !usingDirectDeposit(formData);

export default {
  title: content['additional-info-other-payment-title'],
  path: 'additional-information/other-payment-options',
  initialData: {},
  depends: notUsingDirectDeposit,
  uiSchema: {
    ...titleUI(
      content['additional-info-other-payment-title'],
      DirectDepositOtherOptions,
    ),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
